<template>
    <div class="e-container" :style="style">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: `e-container`,
    props: {
        fluid: {type: Boolean},
        maxWidth: {
            type: [String, Number],
            default: 1140
        }
    },
    computed: {
        style() {
            if (this.maxWidth === `none`) {
                return {};
            }
            return {
                maxWidth: this.fluid ? `100%` : `${this.maxWidth}px`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.e-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

@media(max-width: 600px) {
    .e-container {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
